<!-- Hero Section -->
<section class="page-hero">
  <div class="hero-overlay"></div>
  <div class="hero-content">
    <p class="hero-label">THE EXPERIENCE</p>
    <h1 class="hero-title">Our Services</h1>
    <p class="hero-subtitle">Premium natural treatments crafted with the finest products and expert technique</p>
  </div>
</section>

<!-- Hair Services Section -->
<section class="services-section">
  <div class="services-inner">
    <div class="section-header">
      <div class="section-image">
        <img src="https://images.unsplash.com/photo-1522337360788-8b13dee7a37e?w=600&q=80" alt="Natural hair coloring services">
      </div>
      <div class="section-intro">
        <p class="section-label">SIGNATURE SERVICES</p>
        <h2>Hair</h2>
        <p class="section-description">Experience natural, healthy hair through our signature cuts, colors, and treatments using only premium, sustainable products.</p>
      </div>
    </div>
    <div class="services-list-container">
      <ul class="services-list">
        <li class="service-item" *ngFor="let hairService of hairServices;">
          <span class="service-name">{{hairService.name}}</span>
          <span class="service-dots"></span>
          <span class="service-price">{{hairService.priceText}}</span>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- Hair Extras Section -->
<section class="services-section alt-bg">
  <div class="services-inner">
    <div class="section-header reverse">
      <div class="section-intro">
        <p class="section-label">ENHANCE YOUR EXPERIENCE</p>
        <h2>Hair Care Enhancements</h2>
        <p class="section-description">Nourish and protect your hair's natural integrity with our premium treatments designed for lasting health and beauty.</p>
      </div>
      <div class="section-image">
        <img src="https://images.unsplash.com/photo-1519699047748-de8e457a634e?w=600&q=80" alt="Hair treatment and care">
      </div>
    </div>
    <div class="services-list-container">
      <ul class="services-list">
        <li class="service-item" *ngFor="let hairExtra of hairExtras;">
          <span class="service-name">{{hairExtra.name}}</span>
          <span class="service-dots"></span>
          <span class="service-price">{{hairExtra.priceText}}</span>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- Lash Services Section -->
<section class="services-section">
  <div class="services-inner">
    <div class="section-header">
      <div class="section-image">
        <img src="https://images.pexels.com/photos/3724431/pexels-photo-3724431.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Eyelash extension services">
      </div>
      <div class="section-intro">
        <p class="section-label">LASH ARTISTRY</p>
        <h2>Lashes</h2>
        <p class="section-description">Customized lash extensions designed to frame and elevate your natural beauty, offered by our talented team of lash artists.</p>
      </div>
    </div>
    <div class="services-list-container">
      <ul class="services-list">
        <li class="service-item" *ngFor="let lashService of lashServices;">
          <span class="service-name">{{lashService.name}}</span>
          <span class="service-dots"></span>
          <span class="service-price">{{lashService.priceText}}</span>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- Nail Services Section -->
<section class="services-section alt-bg">
  <div class="services-inner">
    <div class="section-header reverse">
      <div class="section-intro">
        <p class="section-label">NAIL ARTISTRY</p>
        <h2>Nails</h2>
        <p class="section-description">Professional Gel-X and builder gel sets by Hannah, crafted for durable, flawless, and beautifully finished nails.</p>
      </div>
      <div class="section-image">
        <img src="https://images.unsplash.com/photo-1604654894610-df63bc536371?w=600&q=80" alt="Gel-X nail services">
      </div>
    </div>
    <div class="services-list-container">
      <ul class="services-list">
        <li class="service-item" *ngFor="let nailService of nailServices;">
          <span class="service-name">{{nailService.name}}</span>
          <span class="service-dots"></span>
          <span class="service-price">{{nailService.priceText}}</span>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- Other Services Section -->
<section class="services-section">
  <div class="services-inner">
    <div class="section-header">
      <div class="section-image">
        <img src="https://images.pexels.com/photos/29588096/pexels-photo-29588096.jpeg?auto=compress&cs=tinysrgb&w=600" alt="Brow and waxing services">
      </div>
      <div class="section-intro">
        <p class="section-label">FINISHING TOUCHES</p>
        <h2>Brows &amp; Waxing</h2>
        <p class="section-description">Complete your look with our brow, lash lift, waxing, and permanent makeup services.</p>
      </div>
    </div>
    <div class="services-list-container">
      <ul class="services-list">
        <li class="service-item" *ngFor="let otherService of otherServices;">
          <span class="service-name">{{otherService.name}}</span>
          <span class="service-dots"></span>
          <span class="service-price">{{otherService.priceText}}</span>
        </li>
      </ul>
    </div>
  </div>
</section>

<!-- CTA Section -->
<section class="services-cta">
  <h2>Ready to Book?</h2>
  <p>Experience the difference premium natural care makes.</p>
  <button type="button" class="cta-button" (click)="booking.open()">Reserve Your Appointment</button>
</section>